import axios from "axios";
import { addErrorLog, addInfoLog } from "Logger/logger";
import { getQuery } from "./PaymentGatewayWrapper";
import { getEnv } from "helpers/environment";

export const getCustomer = async (email) => {
  try {
    const response = await axios.post(
      getEnv("PAYMENT_GATEWAY") + getEnv("ROUTES_CUSTOMER") + getEnv("APIS_SEARCH_CUSTOMER"),
      { email: email }
    );
    return response?.data?.data[0];
  } catch (error) {
    addErrorLog("error", error);
  }
};

export const getSubscriptionAndProductInfo = async (customerId) => {
  try {
    const data = JSON.stringify({
      query: `
      query GetSubscriptionAndProductInfo($customerId: String!) {
        getSubscriptionAndProductInfo(customer_id: $customerId) {
          isSuccessful
          message
          resultObject
        }
      }
      `,
      variables: {
        customerId: customerId
      }
    });
    const response = await getQuery(data);
    addInfoLog("getSubscriptionAndProductInfo", response?.getSubscriptionAndProductInfo);
    return response?.getSubscriptionAndProductInfo;
  } catch (error) {
    addErrorLog("error", error);
    return null;
  }
};

export const getCustomerSubscription = async (customer_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetSubscription($customerId: String!) {
        getSubscription(customer_id: $customerId) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        customerId: customer_id
      }
    });
    const response = await getQuery(data);
    return response?.getSubscription;
  } catch (error) {
    console.log(error);
  }
};
